var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._b({},'div',_vm.$attrs,false),_vm._l((_vm.checkboxs),function(checkbox){return _c('el-checkbox',_vm._g({key:checkbox.label,class:_vm.itemClass,attrs:{"value":_vm.value,"checked":_vm.checked,"label":checkbox.label}},_vm.$listeners),[_vm._t("default")],2)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }